/**
 * Persisted framework audit logs hydrate auditQuestionMem but the results column
 * stays collapsed until auditsRan[slug] is true. Auto-expand when blocking
 * failures remain visible after profile filtering.
 */
export const shouldExpandPersistedFrameworkAuditResults = (
  blockingIssueCount: number,
  persistedIssueCount = 0,
): boolean => blockingIssueCount > 0 || persistedIssueCount > 0;

export const markPersistedFrameworkAuditExpanded = (
  auditsRan: Record<string, boolean>,
  auditSlug: string,
  blockingIssueCount: number,
  persistedIssueCount = 0,
): void => {
  if (shouldExpandPersistedFrameworkAuditResults(blockingIssueCount, persistedIssueCount)) {
    auditsRan[auditSlug] = true;
  }
};
